module.exports = __webpack_public_path__ + "img/logo.bf89430.png";